export default class ScrollToLoad {

    private static _instance: ScrollToLoad;

    private callbackList: Array<()=>void> = [];
    private timeout: ReturnType<typeof setTimeout> | null = null;
    private isOn: boolean = true;
    private pane!: HTMLElement | Window;
    private opt!: { except: number; };
    private lastYPos!: number;

    public static get instance() {
        return this._instance || (this._instance = new this())
    }

    public addCallback(_fn: ()=>void) {
        this.callbackList.push(_fn);
    }

    init(_pane: HTMLElement | Window, _option:{except: number}={except: 0}) {
        this.pane = _pane;
        this.opt = _option;
        this.pane.addEventListener('scroll', this.handler.bind(this));
        


    }

    handler(e: Event){
        if (window === this.pane) {
            if (this.lastYPos>this.pane.scrollY || !this.isOn) {
                this.lastYPos = this.pane.scrollY;
                return;
            }
            if (this.pane.scrollY + this.pane.innerHeight + this.opt.except > document.body.clientHeight) {
                if(this.timeout){
                    clearTimeout(this.timeout);
                }
                this.isOn = false;
                this.timeout = setTimeout(() => {
                    this.callbackList.forEach(_fn => _fn());
                }, 50);

                setTimeout(() => (this.isOn = true), 1000);
            }
            this.lastYPos = this.pane.scrollY;
        } else {

        }
    }

    destory() {
        this.pane.removeEventListener('scroll', this.handler.bind(this));
    }


} // end of class